// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Route, Redirect } from 'react-router-dom';
import { querystring } from '../../infrastructure/utils/common';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ component: C, props: cProps, ...rest }) => {
  const redirect = querystring('redirect');
  return (
    <Route
      {...rest}
      render={props =>
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        !cProps.isAuthenticated ? (
          <C {...props} {...cProps} />
        ) : (
          <Redirect to={redirect === '' || redirect == null ? '/' : redirect} />
        )
      }
    />
  );
};
